import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { FileFragment } from '@school_ify/schoolify-repository/src/shared/types';

import FileUploader from 'clean/components/common/FileUploader/FileUploader';

import './Files.scoped.scss';

interface IProp {
  files: Array<FileFragment>;
}

const ShowStudyFiles: React.FC<IProp> = ({ files }) => {
  const { t } = useTranslation();
  const [showFiles, setShowFiles] = useState([]);

  useEffect(() => {
    if (files) {
      setShowFiles(
        files.map(file => {
          const dummyFile = new File([''], file.file_name);
          Object.defineProperty(dummyFile, 'id', {
            value: file.id,
            writable: false,
          });
          return dummyFile;
        })
      );
    }
  }, [files]);

  return (
    <div className="mb-2 mt-2 additional-documents">
      <div className="flex justify-between mb-3 mt-2 align-center">
        <h1 className="header">{t('study:Additional_documents')}</h1>
      </div>
      <FileUploader readOnly={true} files={showFiles} />
    </div>
  );
};

export default ShowStudyFiles;
